import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'ImagePipe'
})
export class ImagePipe implements PipeTransform {
  transform(imgArr: any[], imageType: string): string {
    const found = imgArr.find(i => i.type === imageType);
    return found ? found.url : 'assets/image/image-not-found.png';
  }
}

@Pipe({
  name: 'DocumentPipe'
})
export class DocumentPipe implements PipeTransform {
  transform(docArr: any[], docType: string): string {
    const found = docArr.find(i => i.type === docType);
    return found ? found.url : 'notFound';
  }
}

@Pipe({
  name: 'languagePipe'
})
export class LanguagePipe implements PipeTransform {
  transform(doc: { en: string, hi: string }, choose: 'en' | 'hi' = 'en'): string {

    return doc ? doc[choose] : '';
  }
}

@Pipe({
  name: 'defaultImagePipe'
})
export class DefaultImagePipe implements PipeTransform {
  transform(image: string | undefined): string {
    return image || '/assets/image/appsrihno-logo.svg';
  }
}

@Pipe({
  name: 'removeUnderscore'
})
export class RemoveUnderscorePipe implements PipeTransform {
  transform(key: string): string {
    return key.replace(/_/g, ' ');
  }
}

@Pipe({
  name: 'nameFormatPipe'
})
export class NameFormatPipe implements PipeTransform {
  transform(key: string): string {
   
    if (key === 'CANCELLED_CHECK') {
      return 'cancelled cheque';
    } else if (key === 'T&C') {
      return 'Contract Document to Sign';
    }else if (key === 'INDIAN_MEDICAL_COUNCIL') {
      return 'State Medical Council';
    } else if (key === 'NABL') {
      return 'Upload NABL/ CMO/ Other Accredited Authorities';
    }

    return key.split('_')
      .join(' ')
      .toLowerCase();
  }
}

@Pipe({
  name: 'documentNamePipe'
})
export class DocumentNamePipe implements PipeTransform {
  transform(key: string): string {
    if (key) {
      const urlArray = key.split('/');
      return urlArray[urlArray.length - 1];
    }
    return '';
  }
}

@Pipe({
  name: 'campFacilityPipe'
})
export class CampFacilityPipe implements PipeTransform {
  transform(doc: Array<any>): string {
    if (!doc) {
      return '';
    }
    let facility = doc.map(i => i.name.en);
    return facility.toString();
  }
}

@Pipe({
  name: 'campServicePipe'
})
export class CampServicePipe implements PipeTransform {
  transform(services: Array<any>, selectedServices: Array<any>): string {
    let serviceArray:any = [];
    if (!(selectedServices || []).length) {
      return '';
    }
    (selectedServices || []).forEach(i => {
      if((services || []).includes(String(i._id))){
        serviceArray.push(i.title?.en)
      }
    });
    return serviceArray.toString();
  }
}

@Pipe({
  name: 'campPaymentFlowPipe'
})
export class CampPaymentFlowPipe implements PipeTransform {
  transform(flow: String): string {
    return flow ? flow.split('_').join(" ") : '';
  }
}
